import _ from 'lodash'
const SLIDER_HISTORY_CONFIG = {
    section: _.select( '.c-section--us-history' ),
    slider: _.select( '.c-section--us-history .slider' ),
}

export default SLIDER_HISTORY_CONFIG